function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#61b2e4",
  d: "M60 61H12a1 1 0 0 1-1-1V12a1 1 0 0 1 1-1h48a1 1 0 0 1 1 1v48a1 1 0 0 1-1 1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m33.963 43.459-1.067 14.944h-8L23.828 43.46m7.403-2.265s-5.607.338-5.733.41c-.127.073 1.162-1.614.972-3.484 0 0 3.042 1.038 5.883-.52l-1.122 3.594zm11.395-15.552s-.544 3.95-2.998 6.908c-.592.712-2.757 2.088-3.357 2.34-2.25.942-4.483-.148-4.483-.148l5.938-3.63 1.84-5.32 3.06-.15z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m52.676 41.284-.653-16.041c-.095-1.898-1.617-3.392-3.473-3.41h-4.952c-1.856.018-3.378 1.512-3.473 3.41l1.104 2.044c-.005.107.15.602.107.7l.466 11.93-.77 18.244c-.026.26.22.538.378.743a.2.2 0 0 0 .125.074c.177 0 .542-.353.608-.928l2.097-18.596a4.11 4.11 0 0 1 .29-1.107l.813-.514h1.34l.599.665c.127.325.291.636.332.984l2.392 18.57c.065.576.43.928.607.928a.2.2 0 0 0 .125-.074c.159-.205.233-.465.206-.726l-.589-18.264 2.421 1.728a.84.84 0 0 1-.1-.36z"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 45.992,
  cy: 16.51,
  r: 2.375,
  fill: "#FFF"
});

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M60 61H12a1 1 0 0 1-1-1V12a1 1 0 0 1 1-1h48a1 1 0 0 1 1 1v48a1 1 0 0 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "m33.896 44.403-1 14h-8l-1-14"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.827,
  d: "M31.231 41.195s-5.607.338-5.733.41c-.127.073 1.162-1.614.972-3.484 0 0 3.042 1.038 5.883-.52l-1.122 3.594z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45.992,
  cy: 16.51,
  r: 2.375,
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m50.017 26.86 1.52 30.4c.044.88-.46 1.6-1.12 1.6a1.66 1.66 0 0 1-1.383-1.589l-2.031-17.625c-.1-.874-.543-1.59-.983-1.59-.44 0-.88.716-.983 1.59l-2.034 17.625a1.66 1.66 0 0 1-1.383 1.59c-.66 0-1.164-.72-1.12-1.6l1.52-30.4"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M32.146 33.833s3.92-1.416 5-3c1.045-1.532 4.245-8.975 6.471-9h4.8a4.22 4.22 0 0 1 4.167 4l.633 15.2"
}));

var SvgGarbage = function SvgGarbage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGarbage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/garbage.99ba389d.svg";
export { ForwardRef as ReactComponent };